import { useMediaQuery } from '@mui/material';

export default function useTablet() {
    return useMediaQuery('(max-width: 992px)');
}